import { StylesConfig } from 'react-select';
import { OptionType } from '../index.types';

/**
 * Custom styles for the autocomplete component
 */
export const customStyles = (
  optionsCount = 0
): StylesConfig<OptionType, true> => ({
  control: (base, state) => ({
    ...base,
    border: `1px solid var(${state.isFocused ? '--primary' : '--input'})`,
    boxShadow: 'none',
    '&:hover': {
      border: state.isFocused
        ? '1px solid var(--primary)'
        : '1px solid var(--input)',
    },
    minWidth: 0,
    width: '100%',
    minHeight: '36px', // match height of others form inputs
  }),
  placeholder: (base) => ({
    ...base,
    color: 'var(--muted-foreground)',
    fontSize: 'var(--text-sm)',
    marginTop: '0',
    position: 'static',
    textAlign: 'left',
  }),
  indicatorsContainer: (base) => ({
    ...base,
    flexShrink: 0,
  }),
  valueContainer: (base) => ({
    ...base,
    gap: '4px',
    paddingTop: '4px',
    paddingBottom: '4px',
    flexWrap: 'wrap',
    overflowY: 'auto',
    maxHeight: '110px',
    '&::-webkit-scrollbar': {
      width: '6px',
    },
    '&::-webkit-scrollbar-track': {
      background: 'transparent',
    },
    '&::-webkit-scrollbar-thumb': {
      background: 'var(--border)',
      borderRadius: '3px',
    },
    '&::-webkit-scrollbar-thumb:hover': {
      background: 'var(--muted-foreground)',
    },
  }),
  container: (base) => ({
    ...base,
    width: '100%',
    minWidth: 0,
  }),
  multiValue: (base) => ({
    ...base,
    maxWidth: '100%',
    overflow: 'hidden',
    marginTop: '1px',
    marginBottom: '1px',
  }),
  multiValueLabel: (base) => ({
    ...base,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  }),
  menuList: (base) => ({
    ...base,
    paddingTop: 0,
    paddingBottom: 0,
    maxHeight: '340px',
    '&::-webkit-scrollbar': {
      width: '6px',
    },
    '&::-webkit-scrollbar-thumb': {
      background: 'var(--border)',
      borderRadius: '3px',
    },
  }),
  menu: (base) => ({
    ...base,
    zIndex: 1000,
  }),
  input: (base) => ({
    ...base,
  }),
  option: (base, state) => ({
    ...base,
    paddingTop: '0',
    paddingBottom: '0',
    opacity: state.isDisabled ? 0.3 : 1,
    backgroundColor:
      optionsCount === 1
        ? 'transparent'
        : state.isFocused
        ? 'var(--muted)'
        : state.isSelected
        ? 'var(--primary)'
        : 'transparent',
    color: state.isFocused
      ? 'var(--accent-foreground)'
      : state.isSelected
      ? 'var(--primary-foreground)'
      : 'var(--foreground)',
    cursor: state.isDisabled ? 'not-allowed' : 'pointer',
    '&:not(:last-child)': {
      borderBottom: '1px solid var(--border)',
    },
    ...(state.isDisabled
      ? {}
      : {
          '&:hover': {
            backgroundColor:
              optionsCount === 1
                ? 'transparent'
                : 'var(--muted)',
            color:
              optionsCount === 1
                ? 'var(--foreground)'
                : 'var(--accent-foreground)',
          },
        }),
  }),
});
